/** How wide the case navigation is with its labels, and as a rail of icons alone. */
export const NAVIGATION_WIDTH = 232;
export const RAIL_WIDTH = 56;

/** How wide the guide of a page is. */
export const GUIDE_WIDTH = 400;
